module.exports = [
  require('./narfell'),
  require('./nelanther_isles'),
  require('./netheril'),
  require('./nimbral'),
  require('./north'),
]
